import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import moment from 'moment';
import {
  Alert,
  Platform,
  Image,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  Linking,
} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import GetDirectionsCard from 'src/Modules/GetDirectionsCard.js';

import {BodyText} from 'src/Modules/CommonView';
import QRCode from 'react-native-qrcode-svg';

import FastImage from '../../Utils/FastImage';
import AddToDeviceModal from 'src/Modules/CommonGame/AddToDeviceModal';

//////////////////// utils
import {apiUpdateUserBadges} from 'src/Utils/apiCalls';

import {updateDataAtPath, createGroupShareLink} from 'src/Utils/fireUtils';

import HuntInfoModal from 'src/ScavengerHunt_v2/HuntInfoModal';
import ModalOmniBar from 'src/Modules/OmniBars/ModalOmniBar';

import CheckBox from 'src/Modules/Native/CheckBox';
import {TouchableWithoutFeedback} from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import {socialShare} from '../../Utils/shareHelper';

import {Fragment} from 'react';

import {ContinueButton} from '../../Modules/CommonView/Buttons';
import CallSupportLine from '../../HeaderComponents/CallSupportLine';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {parseHTML} from '../../Utils/dataHelper';

import {useUserId, useUserInfo} from '../../Hooks/reduxHooks';
import GameLobbyPlayers from './GameLobbyPlayers';
import {
  addChildUser,
  startHunt,
  updateTeamName,
} from '../../Utils/huntFunctions';
import {cloudFlareOptimizeImage} from '../../Utils/helpers';
import {HtmlBlock} from '../../Modules/CommonView/Text';

const GameLobby = () => {
  const {width} = useWindowDimensionsSafe();

  const userId = useUserId();
  const easyUserLevelJoinCode = useUserInfo('easyUserLevelJoinCode');

  const groupInfo = useSelector((state) => state.groupInfo) || {};

  const playTestState = useSelector((state) => state.app_info?.playTestState);

  const [shouldStartFromNameModal, setShouldStartFromNameModal] =
    useState(false);

  console.log('GameLobby', {groupInfo, shouldStartFromNameModal});
  const [showAddPlayers, setShowAddPlayers] = useState();
  const view = 'lobby';
  const [paidTickets, setPaidTickets] = useState(true);

  const {
    players,
    createdBy,
    eventId,
    groupId,
    discoverable = false,
    easyGroupLevelJoinCode,
    description,
    teamName,
    lat,
    long,
    huntType,
    huntPhoto,
  } = groupInfo;

  useEffect(() => {
    try {
      apiUpdateUserBadges();
    } catch (error) {
      console.log({error});
    }
  }, [
    Object.keys(groupInfo?.players || {})?.length,
    groupInfo?.huntStarted,
    groupInfo?.huntQuizStarted,
    groupInfo?.teamName,
  ]);

  const handleNameSubmit = (newName, closeModal, forced) => {
    console.log('handle name submit', {
      newName,
      shouldStartFromNameModal,
    });
    if (!newName) {
      return Alert.alert('A team name is required! Think of something fun!');
    }

    const {groupId, huntType} = groupInfo;
    updateTeamName(groupId, newName);
    closeModal();

    if (shouldStartFromNameModal || forced) {
      setShouldStartFromNameModal(false);
      startHunt(groupId, huntType, eventId);
    }
  };

  const showChangeName = (startHuntAfter = false) => {
    const {teamName = ''} = groupInfo;
    console.log('showChangeName', {groupInfo, teamName});
    navigationRef.navigate('ConfirmModal', {
      titleText: `What do you want to name your group?`,
      titleBodyText: startHuntAfter
        ? 'You are almost there, before you get started pick a fun and exciting name that will help your group stand out from the pack!'
        : 'Pick a fun and exciting name that will help your group stand out from the pack!',
      confirmText: 'Set Team Name',
      showPrompt: true,
      maxLength: 20,
      placeholder: 'Your new team name',
      cancelText: 'Cancel',
      initialPromptText: teamName == "Your Team's Name" ? '' : teamName,
      handleConfirm: (promptText, closeModal) =>
        handleNameSubmit(promptText, closeModal, startHuntAfter),
    });
  };

  const handleStartPress = () => {
    console.log('handle start hunt');
    if (groupInfo?.teamName == `Your Team's Name`) {
      console.log('here 1');
      setShouldStartFromNameModal(0);
      return showChangeName(true);
    }
    const {groupId} = groupInfo;

    navigationRef.navigate('ConfirmModal', {
      handleConfirm: async (handleDone) => {
        if (groupInfo?.teamName == `Your Team's Name`) {
          console.log('here 1');
          setShouldStartFromNameModal(true);
          showChangeName(true);
        } else {
          console.log('here 2');
          startHunt(groupId, huntType, eventId);
        }

        handleDone();
      },
      titleText: 'Start your hunt?',
      titleBodyText: groupInfo?.classic_hunt
        ? `Please confirm that you want to start the hunt NOW for your whole team.`
        : `Please confirm that you're at the starting location and that you want to start the hunt NOW for your whole team.`,
      confirmText: 'Start Hunt Now',
      cancelText: 'Later',
      confirmColor: global?.color?.orange,
      cancelColor: global?.color?.blue,
    });
  };

  useEffect(() => {
    // createGroupShareLink

    const {easyGroupLevelJoinCode, groupId, teamName} = groupInfo;
    if (!teamName || teamName == `Your Team's Name`) {
      showChangeName(false);
    }

    const forceUpdate = false;
    console.log({easyGroupLevelJoinCode});
    if (!easyGroupLevelJoinCode || forceUpdate) {
      console.log('creating a easyGroupLevelJoinCode', {
        code: groupId,
        groupId,
      });
      createGroupShareLink({code: groupId, groupId});
    }
    if (!easyUserLevelJoinCode || forceUpdate) {
      console.log('creating a easyUserLevelJoinCode', {
        code: userId,
        userId,
      });
      createGroupShareLink({code: userId, userId});
    }
    apiUpdateUserBadges();
  }, []);

  const tickets = useSelector(
    (state) => state.user?.info?.tickets?.[groupInfo?.theme || 'Standard'] || 0,
  );

  const checkIfGroupNeedsTicketsToJoin = () => {
    const {theme, isFree} = groupInfo;
    let groupNeedsTicketsToJoin =
      playTestState == false &&
      groupInfo &&
      !eventId &&
      !isFree &&
      !theme?.includes?.('home');

    const isPass = groupInfo?.passId;

    if (isFree || isPass) {
      groupNeedsTicketsToJoin = false;
    }

    if (groupInfo?.indoor_hunt) {
      groupNeedsTicketsToJoin = false;
    }
    return groupNeedsTicketsToJoin;
  };

  /// new ticket purchase functionality
  const navigateToTicketsModal = () => {
    navigationRef.navigate('PurchaseModal', {
      forcedTheme: groupInfo?.theme,
      handleDone: () => {
        setShowAddPlayers(true);
      },
    });
  };

  const addPlayerToYourDevice = async () => {
    const groupNeedsTicketsToJoin = checkIfGroupNeedsTicketsToJoin();

    if (!!groupNeedsTicketsToJoin && (!tickets || tickets < 1)) {
      return navigateToTicketsModal();
    }

    setShowAddPlayers(true);
  };

  const shareInviteCode = (displayedLink) => {
    console.log({displayedLink});
    socialShare(
      {
        description: 'Join My Scavenger Hunt',
        url:
          `Join my scavenger hunt by entering this code ${displayedLink} in the Let's Roam App link on your phone or follow this link: ` +
          displayedLink,
        userId: userId || '',
        thumbnail: null,
      },
      'AddPlayerModal',
      'scavaHunt',
    );
  };

  const toggleType = () => {
    console.log('toggling add players modal');

    if (!tickets || tickets < 1) {
      Alert.alert(
        'You Need Tickets',
        'You need tickets to let people join with your tickets.',
        [
          {
            text: 'Purchase Tickets',
            onPress: () => {
              navigateToTicketsModal();
            },
          },
          {
            text: 'Cancel',
          },
        ],
      );
    } else {
      setPaidTickets(!paidTickets);
    }
  };

  const toggleDiscoverable = async () => {
    const {discoverable = false, groupId = 'error'} = groupInfo;
    console.log('toggleDiscoverable', {discoverable});
    updateDataAtPath(
      `scavengerhunt/groups/${groupId}/discoverable`,
      !discoverable,
    );
  };

  if (!teamName || teamName == `Your Team's Name`) {
    showChangeName();
  }

  const joinCode = groupId;
  const prepaidJoinCode = userId;

  const startingLocation =
    groupInfo?.startingLocation != null
      ? groupInfo?.startingLocation
          .replace(/\d{5},\sU[^>]+/gi, '')
          .replace(/\sUSA/, '')
          .replace(/\sUnited\sStates/, '')
          .replace(/[,;]$/, '')
          .replace(/\s+$/, '')
      : '';

  const showBegin = (players && !players[createdBy]) || eventId;

  var displayedCode = joinCode;
  var displayedLink = joinCode;
  var checked = false;
  if (checkIfGroupNeedsTicketsToJoin() && tickets > 0 && paidTickets) {
    displayedCode = prepaidJoinCode;
    displayedLink = prepaidJoinCode;
    checked = true;
  }

  let qrCode = displayedCode;
  if (paidTickets && easyUserLevelJoinCode) {
    qrCode = `${easyUserLevelJoinCode}?c=${displayedLink}`;
  } else if (easyGroupLevelJoinCode) {
    qrCode = `${easyGroupLevelJoinCode}?c=${displayedLink}`;
  }

  const parsedDescription = parseHTML(description || '');

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: 'white',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}>
      <CallSupportLine />
      {
        //////////////////////////////////////////////////////////////////
        /////////////////////  PLAYERS  //////////////////////////////////
        //////////////////////////////////////////////////////////////////
      }
      {view == 'lobby' && (
        <ScrollView testID="lobbyScroll" contentContainerStyle={{}}>
          <View
            style={{
              width: '100%',
              maxWidth: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <View
              style={{
                width: '100%',
                height: 160,
                position: 'relative',
                backgroundColor: 'black',
                alignContent: 'center',
                alignItems: 'center',
              }}>
              <FastImage
                source={{uri: cloudFlareOptimizeImage(huntPhoto)}}
                style={{
                  height: 160,
                  width: '100%',
                }}
                resizeMode={FastImage?.resizeMode?.cover}
              />
              <View
                testID="gameLobby"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: global?.color?.gray3_50,
                }}>
                <Text
                  style={{
                    color: global?.color?.white,
                    fontFamily: global?.font.gothic,
                    fontSize: 30,
                    textAlign: 'center',
                    marginHorizontal: 30,
                    marginBottom: 5,
                  }}>
                  {'GAME LOBBY'}
                </Text>
                <Text
                  style={{
                    color: global?.color?.white,
                    fontFamily: global?.font.gothic,
                    fontSize: 40,
                    textAlign: 'center',
                    marginHorizontal: 30,
                    marginBottom: 5,
                  }}>
                  {groupInfo?.huntName?.toUpperCase?.()}
                </Text>
              </View>
            </View>
            <BodyText
              textStyle={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                maxWidth: '100%',
                marginTop: Platform.OS == 'web' ? 0 : -20,
                backgroundColor: global.color.blue,
                textAlign: 'center',
                color: 'white',
                paddingTop: 7,
                paddingBottom: 5,
              }}>
              <Text style={{textAlign: 'center'}}>
                {'Start at: '}
                <TouchableWithoutFeedback
                  onPress={() => {
                    if (Platform.OS == 'android') {
                      Linking?.openURL('geo:0,0?q=' + startingLocation);
                    } else {
                      Linking?.openURL(
                        'http://maps.apple.com/?q=' + startingLocation,
                      );
                    }
                  }}
                  style={{textDecorationLine: 'underline'}}>
                  <Text style={{textDecorationLine: 'underline'}}>
                    {startingLocation}
                  </Text>
                </TouchableWithoutFeedback>
              </Text>
            </BodyText>
            <TouchableOpacity
              style={{
                borderBottomColor: global?.color?.gray3,
                paddingBottom: 3,
                minWidth: 250,
                marginTop: 0,
              }}
              onPress={showChangeName}>
              <Text
                style={{
                  color: global?.color?.gray3,
                  fontFamily: global?.font.circular,
                  fontSize: 20,
                  fontWeight: '700',
                  marginLeft: 5,
                  marginTop: 10,
                  textAlign: 'center',
                }}>
                <Text testID="teamName">{`Your Team: ${groupInfo?.teamName}`}</Text>
                <Text style={{marginLeft: 20}}>
                  <Icon
                    name={'pencil'}
                    size={16}
                    color={global?.color?.gray3}
                  />
                </Text>
              </Text>
            </TouchableOpacity>
            <GameLobbyPlayers />
            <View
              style={{
                borderBottomColor: global?.color?.gray3,
                paddingBottom: 3,
                marginTop: 5,
              }}
              onPress={showChangeName}>
              <Text
                style={{
                  color: global?.color?.gray3,
                  fontFamily: global?.font.circular,
                  fontSize: 20,
                  fontWeight: '700',
                  marginLeft: 5,
                  marginTop: 10,
                  textAlign: 'center',
                }}>
                {`Add Players - Different Devices`}
              </Text>
            </View>
            <Text
              style={{
                color: global?.color?.gray3,
                fontFamily: global?.font.circular,
                marginHorizontal: 15,
                textAlign: 'center',
                fontSize: 14,
                marginTop: 5,
                marginBottom: 10,
              }}>
              Have friends scan or enter
              <TouchableOpacity
                testID="addPlayersToDevice"
                onPress={addPlayerToYourDevice}>
                <Text> </Text>
              </TouchableOpacity>
              your invite code
            </Text>
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                maxWidth: '100%',
                backgroundColor: global.color.orange,
                padding: 20,
              }}>
              <TouchableOpacity
                onPress={() => shareInviteCode(qrCode)}
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  position: 'relative',
                }}>
                <View>
                  <BodyText
                    textStyle={{
                      color: 'white',
                      fontSize: 30,
                      lineHeight: 30,
                    }}>
                    Invite Code
                  </BodyText>
                </View>
                <View>
                  <BodyText
                    textStyle={{
                      color: 'white',
                      fontSize: 30,
                      lineHeight: 30,
                    }}>
                    {`${displayedCode?.toUpperCase?.()}  `}
                    <Image
                      style={{
                        width: 24,
                        height: 24,
                        marginBottom: 12,
                        paddingBottom: 5,
                      }}
                      source={
                        Platform?.OS == 'android'
                          ? require('src/Images/andorid_share_icon_white.png')
                          : require('src/Images/ios_share_icon_white.png')
                      }
                    />
                  </BodyText>
                </View>
              </TouchableOpacity>
              <View style={{padding: 10, backgroundColor: 'white'}}>
                <QRCode
                  value={qrCode || displayedLink || ' '}
                  logo={require('src/Images/stickerLogo.png')}
                  logoBackgroundColor="white"
                  size={130}
                  logoSize={30}
                  logoBorderRadius={0}
                  ecl={'M'}
                  backgroundColor={'white'}
                  color={global?.color?.orange}
                />
              </View>
            </View>
            <View
              style={{
                paddingBottom: 3,
                marginTop: 0,
              }}>
              <TouchableOpacity onPress={addPlayerToYourDevice}>
                <Text
                  style={{
                    color: global?.color?.gray3,
                    fontFamily: global?.font.circular,
                    fontSize: 20,
                    fontWeight: '700',
                    marginLeft: 5,
                    marginTop: 20,
                    textAlign: 'center',
                  }}>
                  {`Add Players - Share My Device`}
                </Text>
              </TouchableOpacity>
            </View>
            <Text
              style={{
                color: global?.color?.gray3,
                fontFamily: global?.font.circular,
                marginHorizontal: 15,
                textAlign: 'center',
                fontSize: 14,
                marginTop: 5,
                marginBottom: 0,
              }}>
              Challenges and activities will be sent to this device
            </Text>
            <ContinueButton
              text={'Add Players To My Device'}
              width={300}
              knockout
              handlePress={addPlayerToYourDevice}
              containerStyle={{marginTop: 20}}
            />

            {playTestState == false && (
              <View
                style={{
                  paddingBottom: 3,
                  width: 200,
                  marginTop: 20,
                }}
                onPress={showChangeName}>
                <Text
                  style={{
                    color: global?.color?.gray3,
                    fontFamily: global?.font.circular,
                    fontSize: 20,
                    fontWeight: '700',
                    marginLeft: 5,
                    marginTop: 0,
                    textAlign: 'center',
                  }}>
                  {`Settings`}
                </Text>
              </View>
            )}

            {!!checkIfGroupNeedsTicketsToJoin() && (
              <TouchableOpacity
                style={{
                  alignItems: 'center',
                  flexDirection: 'row',
                  marginHorizontal: 30,
                  marginTop: 5,
                  paddingLeft: 10,
                  width: '100%',
                }}
                onPress={() => {
                  toggleType();
                }}>
                <CheckBox
                  checkBoxColor={global?.color?.gray2}
                  value={checked}
                  onValueChange={() => toggleType()}
                  style={{width: 15, height: 15}}
                />
                <BodyText
                  text={'Allow new players to use my tickets'}
                  textStyle={{
                    marginBottom: 20,
                    marginTop: 15,
                    fontWeight: '700',
                    flex: 1,
                  }}
                />
              </TouchableOpacity>
            )}
            {playTestState == false && (
              <TouchableOpacity
                style={{
                  alignItems: 'center',
                  flexDirection: 'row',
                  marginHorizontal: 30,
                  width: '100%',
                  paddingLeft: 10,
                  marginTop: 0,
                }}
                onPress={() => {
                  toggleDiscoverable();
                }}>
                <CheckBox
                  checkBoxColor={global?.color?.gray2}
                  value={discoverable}
                  onValueChange={() => toggleDiscoverable()}
                  style={{width: 15, height: 15}}
                />
                <BodyText
                  text={`Easy join: group discoverable to nearby devices (Recommended)`}
                  textStyle={{
                    marginBottom: 20,
                    marginTop: 15,
                    fontWeight: '700',
                    flex: 1,
                  }}
                  left
                />
              </TouchableOpacity>
            )}
            {!!parsedDescription && (
              <Fragment>
                <View
                  style={{
                    paddingBottom: 3,
                    width: 300,
                    marginTop: 20,
                  }}>
                  <Text
                    testID="aboutThisHunt"
                    style={{
                      color: global?.color?.gray3,
                      fontFamily: global?.font.circular,
                      fontSize: 20,
                      fontWeight: '700',
                      marginLeft: 5,
                      marginTop: 0,
                      textAlign: 'center',
                    }}>
                    {`About This Scavenger Hunt`}
                  </Text>
                </View>
                <View
                  style={{
                    marginHorizontal: 20,
                    marginVertical: 10,
                  }}>
                  <HtmlBlock
                    baseFontStyle={{
                      textAlign: 'left',
                      fontFamily: 'CircularStd-Book',
                      fontSize: 16,
                      lineHeight: 20,
                      color: '#505759',
                    }}
                    html={parsedDescription || ''}
                  />
                </View>
                {huntType !== 'inHome' && (
                  <GetDirectionsCard
                    starting_location={startingLocation}
                    lat={lat}
                    long={long}
                    hunt={groupInfo}
                    width={width - 40}
                  />
                )}
              </Fragment>
            )}
            <View
              style={{
                paddingBottom: 3,
                width: 300,
                marginTop: 20,
              }}>
              <Text
                style={{
                  color: global?.color?.gray3,
                  fontFamily: global?.font.circular,
                  fontSize: 20,
                  fontWeight: '700',
                  marginLeft: 5,
                  marginTop: 0,
                  textAlign: 'center',
                }}>
                {`Need Help?`}
              </Text>
            </View>
            <ContinueButton
              text={'Contact Support'}
              width={300}
              knockout
              handlePress={() => navigationRef.navigate('SupportModal')}
              containerStyle={{marginTop: 20}}
            />
            <View style={{height: 200, width: 200}} />
          </View>
        </ScrollView>
      )}
      {view == 'about' && <HuntInfoModal currentHunt={groupInfo} />}
      <ModalOmniBar
        left={{
          icon: 'arrow-left-circle',
          handlePress: () => navigationRef.navigate('LandingPageMain'),
          text: 'Exit Lobby',
        }}
        omniButton={{
          icon: require('src/Images/logo.png'),
          color: global?.color?.orange,
          handlePress: () => {
            try {
              if (
                groupInfo?.eventStartTime &&
                new Date() < new Date(groupInfo?.eventStartTime)
              ) {
                const formattedStartDate = moment(
                  new Date(groupInfo?.eventStartTime),
                ).format('MM/DD/YYYY');

                return Alert.alert(
                  `You cannot start the hunt until ${formattedStartDate}. Before then, be sure to invite people to your team to get the max points possible.`,
                );
              }

              if (createdBy === userId || showBegin || groupInfo?.huntStarted) {
                handleStartPress();
              } else {
                Alert.alert(
                  'You Did Not Create The Hunt',
                  `Only the person who made the hunt can start the hunt. Please have the team leader start the hunt or ask them to leave the hunt. `,
                );
              }
            } catch (error) {
              handleStartPress();
            }
          },
          text: groupInfo?.huntStarted ? 'Continue Hunt' : 'Start Hunt',
        }}
        right={{
          icon: 'share',
          handlePress: () => shareInviteCode(qrCode),
          text: 'Share Invite Code',
        }}
        containerStyle={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
        }}
      />
      <AddToDeviceModal
        isVisible={showAddPlayers}
        groupInfo={groupInfo}
        groupId={groupInfo?.groupId}
        closeModal={() => setShowAddPlayers(false)}
        addChildUser={(firstName, parentUserId, parentUserEmail, groupId) => {
          addChildUser(firstName, parentUserId, parentUserEmail, groupId);
        }}
        handleShopPress={() => navigationRef.navigate('PurchaseModal')}
      />
    </View>
  );
};

export default GameLobby;
